export default __webpack_public_path__ + "static/media/cm.6ac72ce2.png";